import React, { useState } from 'react';
import classes from "./AddPublisherModal.module.css";
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { dummyHitApi } from '../http/http';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { removeToken } from '../store/slices/tokenSlice';
import { useNavigate } from 'react-router-dom';

const DummyHitModal = ({ setDummyHitModal, dummyHitModal, token }) => {
    const [url, setUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const dispatch=useDispatch();
    const navigate=useNavigate();

    console.log(dummyHitModal,'dhm');

    const submitHandler = async () => {
        try {
            if (url.trim().length > 0) {
                // try {
                setLoading(true);
                // Open a new window
                const newWindow = window.open(`${url}`, "_blank");

                // Check if the new window is successfully opened
                if (newWindow) {
                    // Set a callback for when the new window is closed
                    newWindow.onunload = async function () {
                        try {

                            const response = await dummyHitApi({
                                postback_url: dummyHitModal?.details?.postback_url, service_name: dummyHitModal?.details?.service_name, pub_name: dummyHitModal?.details?.pub_name
                            }, token);

                            if (response.data.data === "Ok") {
                                toast.success("Success");
                                setLoading(false);
                                setUrl("");
                                setDummyHitModal({ state: false, details: null });
                            } else {
                                setLoading(false);
                                toast.error("Some Error Occurred!");
                                setUrl("");
                                setDummyHitModal({ state: false, details: null });
                            }
                        } catch (error) {
                            setLoading(false);
                            console.error("Error making API request", error);
                            toast.error("Some Error Occurred!");
                            setUrl("");
                            setDummyHitModal({ state: false, details: null });
                        }
                    };
                } else {
                    // Handle the case where the new window couldn't be opened
                    setLoading(false);
                    console.error("Error opening new window");
                    toast.error("Some Error Occurred!");
                    setUrl("");
                    setDummyHitModal({ state: false, details: null });

                }
            } else {
                toast.error("Url is empty!");
            }
        }
        catch (error) {
                setLoading(false);

            console.log(error, 'error');
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    };

    return (
        <Dialog header="Dummy Hit" headerStyle={{ fontFamily: "Ubuntu" }} position='bottom' visible={dummyHitModal?.state} style={{ width: "350px" }} onHide={() => { if (!dummyHitModal?.state) return; setDummyHitModal({ state: false, details: null }); }}>
            <div className={classes.container} style={{ paddingTop: "10px" }}>
                <div className="flex flex-column gap-4">
                    <InputText type="text"
                        value={url} onChange={(e) => setUrl(e.target.value)} className={` ${classes.input}`} placeholder="Service Url" />
                    <small id="username-help">
                        {`Sample: "http://optin.telkomsdp.co.za/service/53?cid=700504&ext_id=<ext_id>" replace ext_id with any random numbers to track the traffic`}
                    </small>
                </div>
                <div className={classes.center_btn}>
                    <button type='button' className={classes.add_btn} onClick={submitHandler} disabled={loading} >
                        {loading ? "Hiting..." : "Hit"}
                    </button>
                </div>
            </div>
        </Dialog>
    )
}

export default DummyHitModal